import { z } from 'zod/v4';

export const AdminDeleteWebshopParamsSchema = z.object({
  id: z.string().min(1),
});

export type AdminDeleteWebshopParams = z.infer<
  typeof AdminDeleteWebshopParamsSchema
>;
